import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core"
import { AssociatedChannel } from "@root/store/types"
import React from "react"

export interface Props {
  associated: AssociatedChannel[]
}

const AssociatedTable: React.FC<Props> = ({ associated }) => {
  const items = associated.map((item, idx) => {
    switch (item.platform) {
      case "email":
        return (
          <TableRow
            key={idx}
            data-qa-selector={`associated-row-email-${item.address}`}
          >
            <TableCell>Email</TableCell>
            <TableCell>address: {item.address}</TableCell>
          </TableRow>
        )
      case "sms":
        return (
          <TableRow
            key={idx}
            data-qa-selector={`associated-row-sms-${item.msisdn}`}
          >
            <TableCell>SMS</TableCell>
            <TableCell>
              msisdn: {item.msisdn}
              <br />
              sender id: {item.senderId}
            </TableCell>
          </TableRow>
        )
      case "open":
        return (
          <TableRow
            key={idx}
            data-qa-selector={`associated-row-open-${item.openPlatformName}-${item.address}`}
          >
            <TableCell>Open</TableCell>
            <TableCell>
              address: {item.address}
              <br />
              platform: {item.openPlatformName}
            </TableCell>
          </TableRow>
        )
    }
  })

  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Platform</TableCell>
            <TableCell>Channel</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>{items}</TableBody>
      </Table>
    </TableContainer>
  )
}

export default AssociatedTable
